import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { AccountFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkAccountPOSTErrorResponse, ParkAccountPOSTRequest, ParkAccountPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchAccount = async (requestData: ParkAccountPOSTRequest): Promise<ParkAccountPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkAccountPOSTSuccessResponse>("/account", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkAccountPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: AccountFailReason.SystemError };
  }
};
